// extracted by mini-css-extract-plugin
module.exports = {"loadingBase":"#257E43","title":"styles_title__1s1o2","avatar":"styles_avatar__T9sf-"};